/**
 * 公共方法
 * guoj
 * 2020.12.25
 */
//计算时间差
function getDayTime(sDate, eDate) {
  var date3 = sDate - eDate.getTime(); //时间差的毫秒数
  //计算出相差天数
  var days = Math.floor(date3 / (24 * 3600 * 1000))
  //计算出小时数
  var leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))
  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))
  //计算相差秒数
  var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000)
  let dateCha = days + "天 " + hours + "小时 " + minutes + " 分钟" + seconds + " 秒";
  return dateCha;
}
//返回 2015-03-19 格式
function FormatDate(datetime) {
  if (datetime == null) {
    return null;
  }
  var y = datetime.getFullYear();
  var m = datetime.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = datetime.getDate();
  d = d < 10 ? '0' + d : d;
  return y + '-' + m + '-' + d;
}
//返回 2009-06-12 17:18:05 格式
function FormatDateTime(datetime) {
  if (datetime == null) {
    return "";
  }
  var year = datetime.getFullYear();
  var month = datetime.getMonth() + 1; //js从0开始取
  var date = datetime.getDate();
  var hour = datetime.getHours();
  var minutes = datetime.getMinutes();
  var second = datetime.getSeconds();
  if (month < 10) {
    month = "0" + month;
  }
  if (date < 10) {
    date = "0" + date;
  }
  if (hour < 10) {
    hour = "0" + hour;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (second < 10) {
    second = "0" + second;
  }
  var time = year + "-" + month + "-" + date + " " + hour + ":" + minutes + ":" + second; //2009-06-12 17:18:05
  return time;
}
//返回  17:18 格式
function FormatTime(datetime) {
  if (datetime == null) {
    return null;
  }
  var hour = datetime.getHours();
  var minutes = datetime.getMinutes();
  if (hour < 10) {
    hour = "0" + hour;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  var time = hour + ":" + minutes; //17:18
  return time;
}

function getDateTime(cellValue) {
  if (cellValue == null || cellValue == '') {
    return false
  } else {
    var dateee = new Date(cellValue).toJSON()
    let str = new Date(+new Date(dateee) + 8 * 3600 * 1000)
      .toISOString()
      .replace(/T/g, ' ')
      .replace(/\.[\d]{3}Z/, '')
    return str
  }
}
//文件导入
function handleUpload(file, fieldList, Callback) {
  let _this = this
  //判断文件类型
  let fileend = file.name.substring(file.name.lastIndexOf('.'))
  let isExcel = fileend === ('.xls' || file.type === 'application/vnd.ms-excel')
  if (!isExcel) {
    this.$message.error('您只能上传.xls格式的文件!')
    return
  }
  //创建文件读取对象
  const fileReader = new FileReader()
  //文件读取完成后触发事件
  fileReader.onload = async ev => {
    try {
      const data = ev.target.result
      // var XLSX = require('xlsx')
      const workbook = XLSX.read(data, {
        type: 'binary' // 以字符编码的方式解析
      })
      const exlname = workbook.SheetNames[0] // 取第一张表
      let exl = XLSX.utils.sheet_to_json(workbook.Sheets[exlname]) // 生成json表格内容
      console.log(exl,'---生成exl')
      const list1 = getList1(workbook)
      exl = AddXlsxData(exl, list1)
      const exl1 = handleDealFilter(exl, fieldList, list1)
      Callback(exl1)

    } catch (e) {
      return false
    }
  }
  //读取文件
  fileReader.readAsBinaryString(file)
  return isExcel
}
// 获取excel第一行的内容获取表头
function getList1(wb) {
  let wbData = wb.Sheets[wb.SheetNames[0]] // 读取的excel单元格内容
  let re = /^[A-Z]1$/ // 匹配excel第一行的内容
  let arr1 = []
  for (let key in wbData) {
    // excel第一行内容赋值给数组
    if (wbData.hasOwnProperty(key)) {
      if (re.test(key)) {
        arr1.push(wbData[key].w)
      }
    }
  }
  return arr1
}

// 增加对应字段空白内容
function AddXlsxData(xlsxData, list1) {
  let addData = null // 空白字段替换值
  for (let i = 0; i < xlsxData.length; i++) {
    // 要被JSON的数组
    for (let j = 0; j < list1.length; j++) {
      // excel第一行内容
      if (!xlsxData[i][list1[j]]) {
        xlsxData[i][list1[j]] = addData
      }
    }
  }
  return xlsxData
}
//json字段名字转换
function handleDealFilter(arr, key, replaceKey) {
  let newArr = []
  console.log(arr,'--返回字段arr')
  arr.forEach((item, index) => {
    for (var i = 0; i < key.length; i++) {
      item[key[i]] = item[replaceKey[i]]
    }
    newArr.push(item)
  })
  console.log(newArr,'--返回字段newArr')
  return newArr
}

//根据value获取中文名称，datas数据集合，text数据值
function getSelectValue(datas, text) {
  console.log(datas, text)
  var str = text;
  if (text == null) {
    str = "";
  } else if (datas == null) {
    str = text;
  } else {
    for (var i = 0; i < datas.length; i++) {
      console.log(datas[i].text,text)
      if (datas[i].text == text) {
        str = datas[i].value

      };
    }
  }
  console.log(str)
  return str;
}

const toHHmmss = function(data) {
  var s;
  var hours = parseInt((data % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = parseInt((data % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = parseInt((data % (1000 * 60)) / 1000);
  s = (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ?
    ('0' + seconds) : seconds);
  return s;
};

function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
        location.href
      ) || [, ''])[1].replace(/\+/g, '%20')
    ) || null
  );
}
export default {
  FormatDate,
  FormatDateTime,
  FormatTime,
  getDayTime,
  getDateTime,
  handleUpload,
  getSelectValue,
  toHHmmss,
  getUrlKey
}
